import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { HtmlSafe } from 'polaris-coreweb/exports';
import { withPolaris } from 'Components/protons/Polaris';

import { Accordion } from 'Components/organisms/Accordion';

import './_style.scss';

const AccordionFAQs = (props) => {
  const {
    context: {
      cssPrefix,
    },
    data,
    iconClose,
    iconOpen,
  } = props;

  const hasData = (Array.isArray(data) && data.length !== 0);

  // Translate data from 'question/answer' to 'title/content'
  const convertData = () => data.map(({ question, answer }) => ({
    title: question,
    content: <HtmlSafe html={answer} />,
  }));

  const title = 'Frequently Asked Questions';

  const createMainEntity = (faqsdata) => faqsdata.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  }));

  if (hasData) {
    // Structured data
    const jsonld = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: createMainEntity(data),
    };

    useEffect(() => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(jsonld);
      document.head.appendChild(script);
      return () => document.head.removeChild(script);
    }, []);
  }

  return (
    <div className={`${cssPrefix}__accordionfaqs-section`}>
      <h3 className={`${cssPrefix}__accordionfaqs-section--title`}>{title}</h3>
      <div className={`${cssPrefix}__content`}>
        {hasData && (
        <Accordion
          items={convertData()}
          exclusive={false}
          iconClose={iconClose}
          iconOpen={iconOpen}
        />
        )}
      </div>
    </div>
  );
};

AccordionFAQs.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  iconClose: PropTypes.string,
  iconOpen: PropTypes.string,
};

AccordionFAQs.defaultProps = {
  context: {
    cssPrefix: 'polaris',
  },
  data: [],
  iconClose: 'polaris__ico-arrow_up',
  iconOpen: 'polaris__ico-arrow_down',
};

export default withPolaris(AccordionFAQs);
